// Regex captures a leading emoji grapheme cluster per the current Unicode standard:
// flags (regional indicator pairs), skin-tone modifiers, ZWJ sequences, variation
// selectors, and tag-sequence flags. Used instead of Intl.Segmenter, which is not
// available in all supported runtimes.
const EMOJI_PREFIX_REGEX = new RegExp(
    "^(?:" +
        "\\p{Regional_Indicator}\\p{Regional_Indicator}" +
        "|\\p{Extended_Pictographic}" +
        "(?:\\u{FE0F}|\\p{Emoji_Modifier}|[\\u{E0020}-\\u{E007E}]+\\u{E007F})?" +
        "(?:\\u{200D}\\p{Extended_Pictographic}(?:\\u{FE0F}|\\p{Emoji_Modifier})?)*" +
        ")",
    "u",
);
const LEADING_WHITESPACE_REGEX = /^\s+(.*)$/;

export const splitEmojiPrefix = (label: string): { emoji: string | null; rest: string } => {
    const emojiMatch = label.match(EMOJI_PREFIX_REGEX);
    if (!emojiMatch) {
        return { emoji: null, rest: label };
    }
    const afterEmoji = label.slice(emojiMatch[0].length);
    const restMatch = afterEmoji.match(LEADING_WHITESPACE_REGEX);
    if (!restMatch) {
        return { emoji: null, rest: label };
    }
    return { emoji: emojiMatch[0], rest: restMatch[1] };
};
